export default __webpack_public_path__ + "static/media/whatsappSlide6.408934e2.svg";